import React from "react";
import { Container } from "react-bootstrap";

export const Transfers: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                Transfers
            </Container>
        </React.Fragment>
    );
}